<div class="page-container proxy-container container">
  <app-utility-toolbar />
  <kendo-grid
    #proxyGrid
    class="col-12"
    [scrollable]="'none'"
    [kendoGridBinding]="gridData"
    [pageSize]="50"
    [pageable]="true"
    [sortable]="true"
    [filterable]="'menu'"
    [selectable]="'single'"
    [navigable]="true"
    (selectionChange)="startProxy(proxyGrid, $event)"
  >
    @for (column of columns; track column) {
      <kendo-grid-column
        [field]="column['data']"
        [title]="column['label']"
        [sortable]="column['sortable']"
        [filterable]="'false'"
        [media]="column['RespVis']"
      />
    }
  </kendo-grid>
</div>
